import styled from "styled-components";
export const MinusMarginContainer = styled.div`
	margin-left: ${({ minusMargin }) => `-${minusMargin}`};
	margin-right: ${({ minusMargin }) => `-${minusMargin}`};
`;
